
<div class="dialog-component">
  <div class="cross">
    <button
      id="desktop-focus-nationality"
      tabindex="0"
      type="button"
      class="close close-btn"
      aria-label="Close"
      (click) ="dialogData.reset()"
    ></button>
  </div>

  <div class="image-container">
    <div class="profile-photo-header">
      <button
        id="mob-focus-nationality"
        tabindex="0"
        type="button"
        class="close close-btn"
        aria-label="Close"
        (click) ="dialogData.reset()"
      ></button>
    </div>



    <div class="edit-nationality-body">
      @if (dialogData.nationalityError) {
        <div role="alert" aria-label="error" class="page-error">
          <label>Sorry, no matching country found. Please enter another.</label>
        </div>
      }
      <label class="dob-label"> Nationality </label>
      <div class="cannot-edit-profile-rectangle">

        <input sanitizeInputForm type="text" matInput
          [formControl]="dialogData.myControl"
          [matAutocomplete]="auto"
          />
          <mat-autocomplete #auto="matAutocomplete">
            @for (option of ((dialogData.filteredOptions | async) ?? []); track option) {
              <mat-option
                [value]="option.Name"
                >
                {{ option.Name }}
              </mat-option>
            }
          </mat-autocomplete>

        </div>

        <div class="btn-container nationality-button">
          <button tabindex="0" role="button" aria-label="save" class="send-button" (click)="dialogData.saveNationalityDetails()" >
            Save
          </button>
        </div>
      </div>


    </div>
  </div>


